import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Preloader from "../../../../../../../../app/components/preloader/Preloader";
import * as selectors from "../../../../../../../../core/store/selectors";
import { TabsData } from "../../../../../../types/bigForm";
import ModalFieldBody from "./ModalFieldBody";

type PropsType = {
  modal: string;
  modalIndex?: number;
  propsalId: number;
  propsalIdsReal?: number[];
  isMultiple: boolean;
};

const ModalField: React.FC<PropsType> = ({
  modal,
  modalIndex,
  propsalIdsReal,
  isMultiple,
}: PropsType) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [open, setOpen] = useState<boolean>(false);
  const [tabsData, setTabsData] = useState<TabsData>();
  const modalPropsalId = useSelector(selectors.modalPropsalId);
  const modalErrors = useSelector(selectors.currentEditModalErrors);
  const modalField = useSelector(selectors.modalField);
  const [tab, setTab] = useState<string>("");
  const [tabsError, setTabsError] = useState<string[]>([]);
  const [showPreloader, setShowPreloader] = useState<boolean>(false);

  useEffect(() => {
    if (modalField) {
      const fields = modalField.childs;
      let tabsObj: Record<string, string[]> = {};
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (field.category) {
          if (!tabsObj.hasOwnProperty(field.category)) {
            tabsObj[field.category] = [];
          }
          tabsObj[field.category] = [...tabsObj[field.category], field.name];
        }
      }
      setTabsData({
        tabs: Object.keys(tabsObj),
        tabsFields: tabsObj,
      });
      setTab(Object.keys(tabsObj)[0]);
    }
  }, [modalField]);

  useEffect(() => {
    if (modalField) {
      const fields = modalField.childs;
      const tabsErr = new Set<string>();
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (field.category) {
          if (
            modalErrors &&
            modalErrors?.[modalIndex ?? 0]?.[field.name]?.length > 0
          ) {
            tabsErr.add(field.category);
          }
        }
      }
      setTabsError(Array.from(tabsErr));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalField, modalErrors]);

  return (
    <>
      {modalField && modal && modalPropsalId && (
        <>
          <ModalFieldBody
            modalName={modal}
            modalIndex={modalIndex}
            propsalId={modalPropsalId}
            modalField={modalField}
            tabsData={tabsData}
            tab={tab}
            tabsError={tabsError}
            setTab={setTab}
            setOpen={setOpen}
            setShowPreloader={setShowPreloader}
            key={`modalfield_${modalIndex}`}
            propsalIdsReal={propsalIdsReal}
            isMultiple={isMultiple}
          />
          {showPreloader && <Preloader preloaderType={"absolute"} />}
        </>
      )}
    </>
  );
};

export default React.memo(ModalField);
